<div class="date-selector">
    <form [formGroup]="form">
        <fieldset [disabled]="isSubmitting">
            <div fxLayout="row wrap" fxLayoutAlign="start center" >
                <div>
                    <mat-form-field [hintLabel]="'date_format_hint' | translate">
                        <mat-label class="required">{{ 'DateFrom' | translate }}</mat-label>
                        <input matInput formControlName="dateFrom" [matDatepicker]="pickerDateFrom" autocomplete="off" (dateChange)="handleFromDateChange($event)">
                        <mat-datepicker-toggle matSuffix [for]="pickerDateFrom"></mat-datepicker-toggle>
                        <mat-datepicker #pickerDateFrom startView="year"></mat-datepicker>
                        <mat-error *ngIf="f['dateFrom'].errors && f['dateFrom'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                        <mat-error *ngIf="f['dateFrom'].errors && f['dateFrom'].hasError('lessThan')">{{ 'Field_less_than_end' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field [hintLabel]="'date_format_hint' | translate">
                        <mat-label class="required">{{ 'DateTo' | translate }}</mat-label>
                        <input matInput formControlName="dateTo" [matDatepicker]="pickerDateTo" autocomplete="off" (dateChange)="handleToDateChange($event)">
                        <mat-datepicker-toggle matSuffix [for]="pickerDateTo"></mat-datepicker-toggle>
                        <mat-datepicker #pickerDateTo startView="year"></mat-datepicker>
                        <mat-error *ngIf="f['dateTo'].errors && f['dateTo'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                        <mat-error *ngIf="f['dateTo'].errors && f['dateTo'].hasError('moreThan')">{{ 'Field_less_than_end' | translate }}</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </fieldset>
    </form>
</div>
